module.exports = require("@native-ads/antd/dist/@native-ads/antd.css");


//////////////////
// WEBPACK FOOTER
// external "@native-ads/antd/dist/@native-ads/antd.css"
// module id = 116
// module chunks = 0